import { motion } from "framer-motion";
import { CheckCircle2, Phone, Calendar, Monitor } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { TRANSPARENCY_ITEMS } from "@/data/content";

export default function Transparencia() {
  return (
    <div data-testid="transparencia-page">
      <div className="bg-secondary text-secondary-foreground py-16 grain relative overflow-hidden">
        <div className="absolute -bottom-16 left-10 h-72 w-72 rounded-full bg-primary/20 blur-3xl" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Compromiso digital</span>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-3 max-w-3xl">Código de Transparencia en la Digitalización</h1>
          <p className="mt-4 text-secondary-foreground/70 max-w-2xl text-lg">Estos son los trámites que Colnexx ha migrado a canales digitales para tu comodidad. Todos pueden realizarse también a través de nuestra línea de atención telefónica.</p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        {/* Desktop table */}
        <div className="hidden md:block rounded-3xl border border-border overflow-hidden">
          <table className="w-full text-left" data-testid="transparency-table">
            <thead className="bg-muted/60">
              <tr className="text-xs uppercase tracking-wider text-muted-foreground">
                <th className="px-6 py-4 font-bold">Trámite disponible</th>
                <th className="px-6 py-4 font-bold">Canal digital</th>
                <th className="px-6 py-4 font-bold">Digitalizado desde</th>
                <th className="px-6 py-4 font-bold">Atención telefónica</th>
              </tr>
            </thead>
            <tbody>
              {TRANSPARENCY_ITEMS.map((t, i) => (
                <tr key={t.tramite} className="border-t border-border hover:bg-muted/30 transition-colors" data-testid={`transparency-row-${i}`}>
                  <td className="px-6 py-4 font-semibold">{t.tramite}</td>
                  <td className="px-6 py-4 text-muted-foreground">{t.canal}</td>
                  <td className="px-6 py-4 text-muted-foreground font-mono text-sm">{t.desde}</td>
                  <td className="px-6 py-4">{t.telefono ? <Badge className="gap-1 bg-emerald-500 hover:bg-emerald-500"><CheckCircle2 className="h-3 w-3" /> Disponible</Badge> : <Badge variant="secondary">No</Badge>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden space-y-4">
          {TRANSPARENCY_ITEMS.map((t, i) => (
            <motion.div key={t.tramite} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }} className="rounded-2xl border border-border bg-card p-5">
              <h3 className="font-display font-bold text-lg mb-3">{t.tramite}</h3>
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2 text-muted-foreground"><Monitor className="h-4 w-4 text-primary" /> {t.canal}</div>
                <div className="flex items-center gap-2 text-muted-foreground"><Calendar className="h-4 w-4 text-primary" /> Desde {t.desde}</div>
                <div className="flex items-center gap-2 text-muted-foreground"><Phone className="h-4 w-4 text-primary" /> {t.telefono ? "Disponible por teléfono" : "Solo digital"}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl bg-accent/60 border border-primary/20 p-6 flex items-start gap-3">
          <Phone className="h-5 w-5 text-primary mt-0.5 shrink-0" />
          <p className="text-sm text-muted-foreground">Si prefieres no usar los canales digitales, todos estos trámites pueden gestionarse a través de nuestra línea de atención telefónica. Nuestro compromiso es que la digitalización sea una opción, nunca una barrera.</p>
        </div>
      </div>
    </div>
  );
}
